import React from 'react'

import { useRestaurant } from '../RestaurantProvider/RestaurantProvider'

import './RestaurantLogo.css'

export const RestaurantLogo = () => {
  const { restaurantInfo } = useRestaurant()
  const { data, loading, error } = restaurantInfo

  if (loading || error) return null

  const { logoUrls } = data.restaurant
  const logoUrl = logoUrls && logoUrls.small && `${logoUrls.small}`

  return <div styleName='logo' style={{ backgroundImage: `url(${logoUrl})` }} />
}
